module.exports = __webpack_public_path__ + "static/media/cuv.06281947.svg";